import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

export default function ScrollIndicator() {
  const [scrollPercent, setScrollPercent] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;

    const updateScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const documentHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      const progress =
        documentHeight > 0 ? Math.min((scrollTop / documentHeight) * 100, 100) : 0;

      setScrollPercent(progress);
      setVisible(scrollTop > 420);

      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScroll);
        ticking = true;
      }
    };

    updateScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const radius = 22;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (scrollPercent / 100) * circumference;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      className={`fixed bottom-6 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-white/90 text-slate-950 shadow-2xl ring-1 ring-slate-200 backdrop-blur-xl transition duration-300 hover:-translate-y-1 hover:shadow-[0_20px_60px_rgba(242,113,49,0.28)] dark:bg-slate-950/90 dark:text-white dark:ring-white/10 ${
        visible
          ? "translate-y-0 opacity-100"
          : "pointer-events-none translate-y-6 opacity-0"
      }`}
      aria-label="Retour en haut de page"
      title="Retour en haut"
    >
      <svg
        className="absolute inset-0 h-14 w-14 -rotate-90"
        viewBox="0 0 56 56"
        aria-hidden="true"
      >
        <circle
          cx="28"
          cy="28"
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          className="text-slate-200 dark:text-white/10"
        />

        <circle
          cx="28"
          cy="28"
          r={radius}
          fill="none"
          stroke="var(--primary-color)"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className="transition-[stroke-dashoffset] duration-150"
        />
      </svg>

      <span className="relative flex h-10 w-10 items-center justify-center rounded-full bg-slate-950 text-white transition hover:bg-primary dark:bg-white dark:text-slate-950 dark:hover:bg-primary dark:hover:text-white">
        <FaArrowUp className="text-sm" />
      </span>
    </button>
  );
}